import { updateObject, } from '../../utils/utility';

const initialState = {
    paymentList: [],
    totalElements: 0,
    pageNumber: 0,
    totalPages: 0
}

const setPaymentsData = (state = initialState, action) => {
    const { paymentList, totalElements, pageNumber, totalPages } = action.payload;
    return updateObject(state, {
        paymentList,
        totalElements,
        pageNumber,
        totalPages
    }
    );
};


const reducer = (state = initialState, action) => {
    if (action.type === "SET_PAYMENTS_LIST") {
        return setPaymentsData(state, action);
    }

    return state;
}

export default reducer;